import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  article {
    max-height: 800px;
    height: fit-content;
    background: var(--overlay-pad-background);
    backdrop-filter: blur(25px);
    border-radius: 0 10px 10px 10px;
    padding: 0 30px 30px 0;
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.4rem;
    font-weight: 600;
    padding: 30px 0 0 30px;
  }
  h2 {
    font-size: 0.8rem;
    padding: 5px 0 0 30px;
    width: 300px;
    line-height: 120%;
  }
  .signin_modal_tabs_wrapper .panel {
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
    display: flex;
    align-items: flex-start;
  }
`
const signInCSS = css`
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/signin.css */
  .signin_modal_tabs_wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    width: 100%;
    padding: 0 0 0 30px;
  }
  .signin_modal_tabs_wrapper .tabs {
    display: none;
  }
  .signin_modal_tabs_wrapper .tab {
    cursor: pointer;
    padding: 10px 20px;
    margin: 0 2px;
    background: transparent;
    border-bottom: 0;
    display: inline-block;
    border-radius: 10px;
    color: rgba(255, 255, 255, 0.5);
    font-size: 0.9rem;
  }
  .signin_modal_tabs_wrapper .panels {
    width: 100%;
    overflow: hidden;
    margin: 15px 0 0 0;
  }
  .signin_modal_tabs_wrapper .panel {
    display: none;
    animation: fadein 0.8s;
    width: 100%;
    padding: 0;
    background: transparent;
    flex-flow: row;
  }
  .signin_modal_tabs_wrapper .radio {
    display: none;
  }
  .panels #register_one-panel {
    display: flex;
    align-items: flex-start;
  }
  .signin_modal_tabs_wrapper #register_one:checked ~ .tabs #register_one-tab,
  .signin_modal_tabs_wrapper #register_two:checked ~ .tabs #register_two-tab {
    background: rgba(255, 255, 255, 0.1);
    font-weight: 600;
    margin-left: -1px;
    color: #b3cbff;
    text-shadow: 0 0 10px hsla(221, 73%, 47%, 1);
  }
  .signin_wrapper {
    flex-flow: column;
    display: flex;
    margin: 0 10px 0 0;
    padding: 0 400px 0 0;
  }
  .signin_wrapper * {
    display: flex;
  }
  .signin_wrapper form {
    flex-flow: column;
  }
  .signin_wrapper form fieldset {
    flex-flow: column;
    border: 0;
    min-width: 300px;
    margin: 15px 0 0 0;
  }
  .signin_wrapper form fieldset label {
    padding: 0 0 6px 0;
  }
  .signin_wrapper form label {
    font-weight: 600;
    font-size: 0.9rem;
    display: flex;
    margin: 0;
  }
  .signin_wrapper form input[type='text'],
  .signin_wrapper form input[type='password'] {
    padding: 12px 15px;
    border-radius: 10px;
    font-size: 0.9rem;
    width: 100%;
    color: #000;
    line-height: 100%;
    outline: 0;
    border: 1px solid #fff;
    position: relative;
    z-index: 0;
  }
  .signin_wrapper form input[type='text']:focus,
  .signin_wrapper form input[type='password']:focus {
    border: 1px solid #2a6dff;
    outline: 0;
    -webkit-box-shadow: 0 0 20px 0 rgba(42, 109, 255, 0.3);
  }
  .signin_wrapper label .required_ast {
    color: #de0e54;
    font-size: 1rem;
    padding: 0 0 0 0.3em;
  }
  .signin_wrapper form .field_error {
    color: #de0e54;
    margin: 5px 0 0 0;
    font-size: 0.8rem;
  }
  .signin_wrapper form button {
    width: 100%;
    padding: 14px;
    font-size: 0.9rem;
    margin: 10px 0 0 0;
  }
  .signin_marketing_panel {
    background: hsla(0, 0%, 0%, 0.2) url('http://yolo.tino.me/wsb_dark/resources/images/signin_bg.jpg') center center /
      auto auto no-repeat;
    background-position: -90px -250px;
    height: 100%;
    width: 240px;
    position: absolute;
    right: 0;
    top: 0;
    border-radius: 0 10px 10px 0;
    display: flex;
    align-items: center;
    flex-flow: column;
    justify-content: space-between;
    padding: 30px;
  }
  .signin_marketing_panel .access_statement {
    font-size: 0.65rem;
    text-align: center;
    line-height: 120%;
  }
  .signin_marketing_panel .client_logo {
    display: flex;
    justify-content: center;
  }
  .signin_marketing_panel .client_logo.wallstreetbets {
    width: 90%;
    height: 100%;
    background: var(--main-logo) center center / contain no-repeat;
  }

  .signin_marketing_panel .user_alternate_access {
    display: flex;
    text-align: center;
    flex-direction: column;
    margin: 30px 0;
  }
  .signin_marketing_panel .user_alternate_access span {
    font-size: 0.8rem;
  }
  .signin_marketing_panel .user_alternate_access button {
    padding: 10px 15px;
    font-size: 0.9rem;
    font-weight: 600;
    margin: 10px 0 0 0;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/dashboard.css */
  .radio {
    display: none;
  }
  .tabs {
    display: flex;
    flex-flow: row;
  }
  /*! CSS Used from: http://yolo.tino.me/wsb_dark/resources/css/wallet.css */
  .radio {
    display: none;
  }

  .user-signin article,
  .user-register article {
    padding-bottom: 30px;
  }
  .signin_wrapper .user_alternate_access.mobile {
    display: none;
  }

  @media (max-width: 600px) {
    .signin_wrapper {
      padding: 0;
      margin: 0;
    }
    .signin_marketing_panel {
      display: none;
    }
    .popUpContainer.user-register,
    .popUpContainer.user-signin {
      max-width: 360px;
    }
    .user-signin article,
    .user-register article {
      padding-bottom: 30px;
      overflow: visible;
      height: fit-content;
      border-radius: 10px;
    }
    .signin_wrapper .user_alternate_access.mobile {
      display: flex;
      text-align: left;
      flex-direction: row;
      margin: 15px 0 0 0;
      padding: 15px 0 0 0;
      justify-content: flex-start;
      align-items: center;
      border-top: 1px solid hsla(0, 0%, 100%, 0.15);
    }
    .signin_wrapper .user_alternate_access.mobile span {
      font-size: 0.8rem;
    }
    .signin_wrapper .user_alternate_access.mobile button {
      padding: 8px 12px;
      font-size: 0.75rem;
      font-weight: 600;
      width: fit-content;
      margin: 0 0 0 15px;
    }
  }
`

const developerCSS = css``

export const SignUpModalCSS = styled.div`
  ${designerCSS}
  ${signInCSS}
  ${developerCSS}
`

export const Close = styled(IconLib).attrs((props) => ({
  collection: 'general',
  name: 'closeOutline',
  dimension: '25px',
}))`
  color: #fff;
  font-size: 1.4rem;
  line-height: 100%;
  position: absolute;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: -8px;
  text-align: center;
  text-decoration: none;
  top: -8px;
  z-index: 1;
  background: rgba(255, 255, 255, 1);

  @media (max-width: 480px) {
    left: -8px;
    top: -8px;
  }
`
